import React from 'react'
import { getFormValues, reset } from 'redux-form'
import { passThroughAwait, passThrough } from 'promise-passthrough'
import { toast } from 'react-toastify'
import {
  FORM_INGRESO_MINIMO,
  FORM_INGRESO_COMPLETO,
  FORM_ABANDONO,
  FORM_DESABANDONO,
  FORM_ANULACION_INGRESO,
  FORM_BUSQUEDACPA,
  FORM_EGRESO,
  FORM_PEDIDO_EGRESO,
  FORM_RECHAZO_EN_PLAYA
} from '../../../config/forms'
import { CebadaCerveceraVariedad } from '../../../config/cereales'
import { getNumericValidator } from '../../Forms/fieldValidators'
import IngresoMinimo from '../../../models/camiones/ingreso_minimo'
import CpaPresunta from '../../../models/camiones/cpa_presunta'
import { Autocomplete } from '../../../models/autocomplete/autocomplete'
// Se utiliza en consulta de disponibilidad de cupo, deberia tener un nombre mas apropiado
import Cpa from '../../../models/camiones/cpa'
import ConsultaCea from '../../../models/calado/consulta_cea'
import IngresoCompleto from '../../../models/camiones/ingreso_completo'
import { setCerealEspecie, setCerealEspecieConVariedad } from '../../Cereal/actions'
import ConsultaCupo from '../../../models/camiones/consulta_cupo'
import ControlTurno from '../../../models/camiones/control_turno'
import Localidad from '../../../models/localidad'
import CpaEnPlaya from '../../../models/camiones/cpa_en_playa'
import PedidoEgreso from '../../../models/camiones/pedido_egreso'
import Printer from '../../../models/impresora'
import CpaAbandonada from '../../../models/camiones/cpa_abandonada'
import Chofer from '../../../models/chofer/chofer'
import NotificacionesChofer from '../../../models/chofer/notificaciones_chofer'
import CargaEntranteAutomotorCalado from '../../../models/calado/carga_entrante_automotor_calado'
import Cereal from '../../../models/cereal/cereal'
import { actualizarDatosParaMuiTable } from '../containers/pedidoEgresoPlaya/pedidoCamionesEnPlaya/actions/TablaPedidoCamionesEnPlayaActions'
import { actualizarDatosParaMuiTable as actualizarDatosParaMuiTableInsatisfecho } from '../../Tablas/pedidoCamionesEnPlayaInsatisfecho/actions/TablaPedidoCamionesEnPlayaInsatisfechoActions'
import { titularCupoCuentayorden, expandirCosecha } from '../../../helpers/cpa'
import ParametroText from '../../../models/parametro/parametro_text'
import moment from 'moment-timezone'
import { cerealAsignadoVolcadora, cerealVolcadoraOriginal } from '../../Volcadora/actions'
import { setShowFooter } from '../../Utils/actions'
import CamionesEnCircuito from '../../../models/camiones/camiones_en_circuito'
import { requestCea, getFoto, resetFoto } from '../../Calado/actions'
import CamionesPenalizados from '../../../models/camiones/camiones_penalizados'
import TablaCamionesEntrePlayaCalado from '../../../models/camiones/tabla_camiones_entre_playa_calado'
import { TablaCamionesListosParaBrutoService } from '../containers/listados/camionesListosParaBruto/servicio/tabla_camiones_listos_para_bruto'
import { TablaCamionesEntreBrutoYDestareService } from '../containers/listados/camionesEntreBrutoYDestare/servicio/tabla_camiones_entre_bruto_y_destare'
import ReingresarCPADialog from '../containers/iMinimo/ReingresarCPADialog'
import CamionAcopladoEjes from '../../../models/camiones/camion_acoplado_ejes'
import { getFotoBruto, resetFotoBruto } from '../../Pesado/actions'
import ParametroInteger from '../../../models/parametro/parametro_integer'

export function hideAbandonoSaveMessageModal () {
  return (dispatch) => dispatch({
    type: 'HIDE_MODAL_ABANDONO_STATUS'
  })
}

export function hideAnulacionIngresoSaveMessageModal () {
  return (dispatch) => dispatch({
    type: 'HIDE_MODAL_ANULACION_INGRESO_STATUS'
  })
}

export function hideSaveMessageModal () {
  return (dispatch) => dispatch({
    type: 'HIDE_MODAL_INFO_COMPLETO_SAVE'
  })
}

export function hideValidacionModal () {
  return (dispatch) => dispatch({
    type: 'HIDE_MODAL_INFO_VALIDACION'
  })
}

export function toogleValidacion () {
  return (dispatch) => dispatch({
    type: 'CAMBIAR_VALIDACION_EXTERNA'
  })
}

export function selectPrinter (printer, printerName) {
  return (dispatch) => {
    dispatch({
      type: 'SELECT_PRINTER_ICOMPLETO',
      printer,
      printerName
    })
  }
}

export function resetPrinter () {
  return (dispatch) => dispatch({ type: 'RESET_PRINTER_ICOMPLETO' })
}

export function submitIngresoMinimoIngreso (callback) {
  return (dispatch, getState) => {
    const state = getState()
    const formValues = getFormValues(FORM_INGRESO_MINIMO)(state)
    const ingresoMinimo = new IngresoMinimo(formValues)
    // Agregar validacion para los pesos tara y bruto, si estan en 0 tienen
    // que llamar al entregador para que modifique la cpe
    console.log('Cereal y variedad', ingresoMinimo.cereal, ingresoMinimo.cerealVariedad)
    let cebadasinvariedad = false
    if (ingresoMinimo.cereal === 'CEBADACE' && ingresoMinimo.cerealVariedad === undefined) {
      cebadasinvariedad = true
    }
    if (ingresoMinimo.numero && ingresoMinimo.camion &&
       (ingresoMinimo.cpeSucursal >= 0) && (ingresoMinimo.cpeSecuencia > 0) &&
       !cebadasinvariedad && formValues.telefonoChofer !== undefined) {
      // if ((formValues.pesoBruto > 0) && (formValues.pesoTara > 0)) {
      if (formValues.telefonoChofer.length > 9) {
        Chofer.actualizarTelefono(formValues.chofer, formValues.telefonoChofer)
          .then(chofer => {
            dispatch({ type: 'ACTUALIZACION_CHOFER', chofer })
          })
        return ingresoMinimo.save()
          .then(saveStatus => {
            dispatch({ type: 'IMINIMO_SAVE_STATUS', saveStatus })
            let {
              data: cupoStatus,
              error
            } = saveStatus
            dispatch({ type: 'RECEIVE_UPDATE_PRESUNTA' })
            CamionesPenalizados.getPenalizadosVigentes(ingresoMinimo.camion, ingresoMinimo.cereal)
              .then((result) => {
                console.log(result)
                if (result && result.patente && (result.patente.trim() === ingresoMinimo.camion.trim() || result.patente.trim() === ingresoMinimo.acoplado.trim())) {
                  const patente = result.patente
                  const motivo = result.motivo
                  const vencimiento = result.fechaVencimiento
                  dispatch({ type: 'TRANSPORTE_TERRESTRE_PENALIZADO', patente, motivo, vencimiento })
                }
              })
            CamionesPenalizados.getPenalizadosVigentes(ingresoMinimo.acoplado, ingresoMinimo.cereal)
              .then((resultado) => {
                console.log(resultado)
                if (resultado && resultado.patente && (resultado.patente.trim() === ingresoMinimo.acoplado.trim() || resultado.patente.trim() === ingresoMinimo.acoplado.trim())) {
                  const patente = resultado.patente
                  const motivo = resultado.motivo
                  const vencimiento = resultado.fechaVencimiento
                  dispatch({ type: 'TRANSPORTE_TERRESTRE_PENALIZADO_ACOPLADO', patente, motivo, vencimiento })
                }
              })
            cupoStatus = cupoStatus.length > 0
              ? cupoStatus[0].cartaDePorteAutomotorIngresoInsert : null
            if (!error) {
              if (cupoStatus !== null) {
                const cupoData = cupoStatus.substr(1, cupoStatus.length - 2).split(',')
                if (cupoData !== null) {
                  const codigoCupo = cupoData[7]
                  if (codigoCupo !== '') {
                    callback && callback(ingresoMinimo.numero, ingresoMinimo.cpeSucursal,
                      ingresoMinimo.cpeSecuencia, ingresoMinimo.cuentayorden)
                  }
                }
              }
            }
          })
      } else {
        toast.error('El Nº de teléfono tiene un largo incorrecto.')
      }
    } else {
      toast.error('Los datos para ingresar la CPE estan incompletos. Si es Cebada Cervecera verifique la Variedad.')
    }
  }
}

function updateEntidadAutocomplete (
  entidad, fieldName, attr, change) {
  return response => {
    return Autocomplete.directSearch(entidad, response[attr])
      .then(matches => {
        let match = matches && matches.shift()
        match = match || ''
        change(fieldName, match)
      })
  }
}

export function updateIminimoFormByPresunta (value, change) {
  return (dispatch) => {
    const validator = getNumericValidator(9, 15)
    const shouldUpdate = (validator(value) === undefined)
    if (shouldUpdate) {
      // Buscar si existe la CPE
      dispatch({ type: 'REQUEST_CPA' })
      Cpa.getConsultaById(value)
        .then(dataCpa => {
          if (dataCpa) {
            ConsultaCea.getById(value)
              .then(dataCpe => {
                if ((dataCpe && (dataCpe.estadoCalificacion === 'R' || dataCpe.rechazoAdministrativoCalado === 'R')) || dataCpa.estadoCtg === 'R') {
                  console.log('Es una CPA rechazada')
                  // Deberia poder realizar el reingreso
                  const result = window.confirm('Esta Carta de Porte fue RECHAZADA ¿Desea realizar el REINGRESO?')
                  if (result) {
                    console.log('Reingresando carta de porte...')
                    // Verificar si esta en presuntas
                    dispatch({ type: 'REQUEST_DATOS_PRESUNTA' })
                    CpaPresunta.getById(value)
                      .then(presunta => {
                        if (presunta) {
                          // Establecer estado ctg Postergado para que se vuelva a validar
                          dispatch(openReingresarCPADialog(dataCpa, presunta))
                        }
                      })
                  } else {
                    // Volver al ingreso
                    dispatch(reset(FORM_INGRESO_MINIMO))
                  }
                } else {
                  // Salir
                  console.log('Es una CPA ya ingresada', dataCpa)
                  window.alert(`Esta Carta de Porte ya se encuentra ingresada con fecha ${moment.unix(dataCpa.fechaDeIngreso).format('DD/MM/YYYY HH:mm')} hs.`)
                  dispatch(reset(FORM_INGRESO_MINIMO))
                }
              })
          } else {
            // Ingreso Normal
            // dispatch({ type: 'REQUEST_UPDATE_PRESUNTA' })
            dispatch({ type: 'REQUEST_PRESUNTA' })
            CpaPresunta.getById(value)
              .then(passThrough(presunta => {
                const cereal = (presunta['cereal']) ? presunta['cereal'] : 'UNDEF'
                change('cereal', cereal)
                // Revisar especie si es Cebada Cervecera replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
                const variedades = CebadaCerveceraVariedad.toString().replace(/,/g, ' ')
                if (cereal === 'CEBADACE' && presunta['observacion'] !== null) {
                  const regex = new RegExp(presunta['observacion'].replace(/\*/g, '').replace(/\|/g, '-').replace(/ /g, '|'), 'ig')
                  const array1 = regex.exec(variedades)
                  if (array1 !== null && array1[0].length > 2) {
                    console.log('RegExp', regex)
                    console.log('Variedad encontrada', array1[0], array1, regex.lastIndex)
                    dispatch(setCerealEspecieConVariedad(cereal, array1[0]))
                    change('cerealVariedad', array1[0])
                  } else {
                    dispatch(setCerealEspecie(cereal))
                    console.log('Deberia ir sin Variedad')
                    // change('cerealVariedad', 'UNDEF  ')
                    // dispatch(setCerealEspecieConVariedad(cereal, 'UNDEF'))
                  }
                } else if (cereal === 'CEBADACE') {
                  console.log('Va por aca, Cebada sin Variedad')
                  dispatch(setCerealEspecie(cereal))
                  // change('cerealVariedad', 'UNDEF  ')
                  // dispatch(setCerealEspecieConVariedad(cereal, 'UNDEF'))
                } else {
                  console.log('Va por aca, no Cebada')
                  dispatch(setCerealEspecie(cereal))
                }
              }))
              .then(passThrough(presunta => {
                const cpeSucursal = presunta.cpeSucursal
                change('cpeSucursal', cpeSucursal)
              }))
              .then(passThrough(presunta => {
                const cpeSecuencia = presunta.cpeSecuencia
                change('cpeSecuencia', cpeSecuencia)
              }))
              .then(passThroughAwait(
                updateEntidadAutocomplete(
                  'exportador', 'exportador', 'exportador', change)))
              .then(passThroughAwait(
                updateEntidadAutocomplete(
                  'corredor', 'corredorComprador', 'corredorComprador', change)))
              .then(passThroughAwait(
                updateEntidadAutocomplete(
                  'corredor', 'corredorVendedor', 'corredorVendedor', change)))
              .then(passThrough(presunta => {
                const camion = presunta.camion ? presunta.camion.trim() : ''
                change('camion', camion)
              }))
              .then(passThrough(presunta => {
                const pesoBruto = presunta.pesoBruto ? presunta.pesoBruto : ''
                change('pesoBruto', pesoBruto)
              }))
              .then(passThrough(presunta => {
                const pesoTara = presunta.pesoTara ? presunta.pesoTara : ''
                change('pesoTara', pesoTara)
              }))
              .then(passThroughAwait(
                updateEntidadAutocomplete(
                  'vendedor', 'vendedor', 'vendedor', change)))
              .then(passThroughAwait(
                updateEntidadAutocomplete(
                  'chofer', 'chofer', 'chofer', change)))
              .then(passThrough(presunta => {
                Chofer.getChofer(presunta.chofer)
                  .then(chofer => {
                    dispatch({ type: 'RECEIVE_CHOFER', chofer })
                    const telefonoChofer = (chofer && chofer.telefono) ? chofer.telefono : ''
                    change('telefonoChofer', telefonoChofer)
                  })
              }))
              .then(passThrough(presunta => {
                change('observacion', presunta.observacion)
              }))
              .then(presunta => {
                // const { titularCp, remitente } = titularRemitente(
                //  presunta.titularDeCupo, presunta.cuentayorden)

                // TitulaDeCupo se preserva para compatibilidad con cp manual
                const titularCp = presunta.cuentayorden
                // const remitente = (presunta.remitenteComercialVentaPrimaria) ? presunta.remitenteComercialVentaPrimaria : presunta.titularDeCupo
                const remitente = presunta.remitenteComercialVentaPrimaria
                const remitenteProductor = presunta.remitenteComercialProductor
                const remitenteVentaSecundaria = presunta.remitenteComercialVentaSecundaria
                const intermediario = presunta.intermediario

                return Promise.all([
                  Autocomplete.directSearch('cargador', titularCp),
                  Autocomplete.directSearch('cargador', remitente),
                  Autocomplete.directSearch('cargador', remitenteProductor),
                  Autocomplete.directSearch('cargador', remitenteVentaSecundaria),
                  Autocomplete.directSearch('cargador', intermediario)
                ])
              })
              .then(([titularCp, remitente, remitenteProductor, remitenteVentaSecundaria, intermediario]) => {
                titularCp = titularCp && titularCp.shift()
                remitente = remitente && remitente.shift()
                remitenteProductor = remitenteProductor && remitenteProductor.shift()
                remitenteVentaSecundaria = remitenteVentaSecundaria.shift()
                titularCp = titularCp || ''
                remitente = remitente || ''
                remitenteProductor = remitenteProductor || ''
                remitenteVentaSecundaria = remitenteVentaSecundaria || ''
                intermediario = intermediario || ''
                change('titular', titularCp)
                change('remitenteComercialVentaPrimaria', remitente)
                change('remitenteComercialProductor', remitenteProductor)
                change('remitenteComercialVentaSecundaria', remitenteVentaSecundaria)
                change('intermediario', intermediario)
                dispatch({ type: 'REQUEST_UPDATE_PRESUNTA' })
                dispatch({ type: 'RECEIVE_PRESUNTA' })
              })
          }
        })
    }
    process.nextTick(dispatch({ type: 'RECEIVE_UPDATE_PRESUNTA' }))
  }
}

export function cambiarEstadoCTG (dataCpa) {
  return (dispatch, getState) => {
    Cpa.desactivarEstadoCtg(dataCpa.numero)
      .then(estado => {
        console.log('Cambio de estado', estado)
        toast.success('El estado del CTG fue modificado exitosamente!')
        // Verificar abondono
      })
      .catch(() => {
        toast.error('Error al cambiar el estado del CTG.')
      })
  }
}

export function openReingresarCPADialog (dataCpa, presunta) {
  return (dispatch, getState) => {
    const confirmCallback = () => {
      cambiarEstadoCTG(dataCpa)(dispatch, getState)
      dispatch({
        type: 'CLOSE_DIALOG',
        id: 'REINGRESAR_CPA'
      })
      dispatch(reset(FORM_INGRESO_MINIMO))
    }
    const cancelCallback = () => {
      dispatch({
        type: 'CLOSE_DIALOG',
        id: 'REINGRESAR_CPA'
      })
      dispatch(reset(FORM_INGRESO_MINIMO))
    }
    dispatch({
      type: 'OPEN_DIALOG',
      id: 'REINGRESAR_CPA',
      maxWidth: 'md',
      content: <ReingresarCPADialog
        confirmCallback={confirmCallback}
        cancelCallback={cancelCallback}
        cpa={dataCpa}
        presunta={presunta}
      />
    })
  }
}

export function iminimoResetStatus () {
  return (dispatch) => {
    dispatch({ type: 'IMINIMO_RESET_STATUS' })
  }
}

export function icompletoResetStatus () {
  return (dispatch) => {
    dispatch({ type: 'RESET_ICOMPLETO' })
  }
}

export function hideModalSinCupo () {
  return dispatch => dispatch({ type: 'ICOMPLETO_HIDE_SIN_CUPO' })
}

export function requestDatosConsultaCpa (numero, callback) {
  return (dispatch) => {
    dispatch({ type: 'REQUEST_CONSULTA_CPA' })
    Cpa.getConsultaById(numero)
      .then(cpa => {
        dispatch({ type: 'RECEIVE_CONSULTA_CPA', cpa })
        callback && callback(cpa)
      })
  }
}

export function requestDatosCpa (numero = null, callback) {
  return (dispatch) => {
    dispatch({ type: 'ICOMPLETO_REQUEST_CPA' })
    // if (numero) {
    Cpa.getById(numero)
      .then(cpa => {
        dispatch({ type: 'ICOMPLETO_RECEIVE_CPA', cpa })
        callback && callback(cpa)
      })
    // }
    // else if (codigoCupo) {
    //   CpaPresunta.getById(numero, codigoCupo)
    //     .then(cpa => {
    //       dispatch({ type: 'ICOMPLETO_RECEIVE_CPA', cpa })
    //       callback && callback(cpa)
    //     })
    // }
  }
}

export function showNoAbandonable () {
  return dispatch => {
    dispatch({ type: 'SHOW_NO_ABANDONABLE',
      abandonoSaveResponse: 'La Carta de Porte no existe o ya se encuentra abandonada.'
    })
  }
}

export function hideNoAbandonable () {
  return dispatch => {
    dispatch({ type: 'HIDE_NO_ABANDONABLE' })
  }
}

export function showNoDesabandonable () {
  return dispatch => {
    dispatch({ type: 'SHOW_NO_DESABANDONABLE',
      desabandonoSaveResponse: 'La Carta de Porte no existe o no se encuentra abandonada.'
    })
  }
}

export function hideNoDesabandonable () {
  return dispatch => {
    dispatch({ type: 'HIDE_NO_DESABANDONABLE' })
  }
}

export function verificarAbandono (numero) {
  return (dispatch) => {
    dispatch(requestDatosCpa(numero, (cpa) => {
      if (cpa && cpa.numero && !cpa.fechaDeAbandono && !cpa.motivoAbandono) {
        dispatch(requestCea(numero, (cea) => {
          if (cea && cea.cartaDePorteAutomotor) {
            if (cea.estadoCalificacion === 'R' || cea.rechazoAdministrativoCalado === 'R') {
              dispatch(abandonoNextStep())
            } else {
              toast.error('No se puede abandonar una carta de porte con proceso de calado sin rechazo previo')
            }
          } else {
            dispatch(abandonoNextStep())
          }
        }))
      } else {
        toast.error('La carta de porte no existe o ya se encuentra abandonada')
      }
    }))
  }
}

export function verificarRechazoEnPlaya (numero) {
  return (dispatch) => {
    dispatch(requestDatosCpa(numero, (cpa) => {
      if (cpa && cpa.numero && !cpa.fechaDeAbandono && !cpa.motivoAbandono) {
        if (cpa.estadoCtg === 'V' && !cpa.fechaDeEgresoPlaya) {
          dispatch(rechazoNextStep())
        } else {
          toast.error('No se puede rechazar una carta de porte que no se encuentra en estado VALIDADO o que ya ha egresado de playa')
        }
      } else {
        toast.error('La carta de porte no existe o se encuentra abandonada')
      }
    }))
  }
}

export function verificarDesabandono (numero) {
  return (dispatch) => {
    dispatch(requestDatosCpa(numero, (cpa) => {
      if (cpa) {
        if (cpa.numero && cpa.fechaDeAbandono && cpa.motivoAbandono) {
          dispatch(desabandonoNextStep())
        } else {
          toast.error('La carta de porte no se encuentra abandonada')
        }
      } else {
        toast.error('No se ha encontrado la Carta de Porte.', { autoClose: false })
      }
    }))
  }
}

export function verificarAnulacionIngreso (numero) {
  return (dispatch) => {
    dispatch(requestDatosCpa(numero, (cpa) => {
      if (cpa && cpa.numero) {
        dispatch(requestCea(numero, (cea) => {
          if (!cea) {
            dispatch(anulacionIngresoNextStep())
          } else {
            toast.error('No se puede anular el ingreso de una carta de porte calada', { autoClose: false })
            dispatch(finalizarAnulacionIngreso())
          }
        }))
      } else {
        toast.error('No se ha encontrado la carta de porte.')
        dispatch(finalizarAnulacionIngreso())
      }
    }))
  }
}

export function getFotoCea (numero) {
  return getFoto(numero)
}

export function getFotoCeaBruto (numero) {
  return getFotoBruto(numero)
}

export function busquedaCpa () {
  return (dispatch, getState) => {
    const state = getState()
    const buscarCpa = getFormValues(FORM_BUSQUEDACPA)(state)
    if (buscarCpa.camion) {
      buscarCpa.camion = buscarCpa.camion.toUpperCase()
    }
    if (buscarCpa.acoplado) {
      buscarCpa.acoplado = buscarCpa.acoplado.toUpperCase()
    }
    // if (buscarCpa.numero && !isNaN(buscarCpa.numero)) {
    //   buscarCpa.numero = `"${buscarCpa.numero}"`
    // }
    if (!isNaN(buscarCpa.numero) || buscarCpa.ctg ||
      buscarCpa.camion || buscarCpa.acoplado) {
      Cpa.busquedaCpa(buscarCpa.numero, buscarCpa.ctg,
        buscarCpa.camion, buscarCpa.acoplado)
        .then(async cpa => {
          if (cpa) {
            Cpa.getConsultaById(cpa.numero)
              .then(estadoCpa => {
                // console.log('estadoCPA', estadoCpa)
                dispatch({
                  type: 'BUSQUEDACPA_CPA',
                  estadoCpa: estadoCpa
                })
                if (estadoCpa.fechaDeCalado) {
                  dispatch(getFotoCea(estadoCpa.numero))
                }
                if (estadoCpa.fechaDeBruto) {
                  dispatch(getFotoCeaBruto(estadoCpa.numero))
                }
              })
            Cpa.detalleCompletoCpa(cpa.numero)
              .then(detalleCompletoCpa => {
                // console.log('detalleCompleto', detalleCompletoCpa)
                dispatch({
                  type: 'BUSQUEDACPA_DETALLE',
                  detalleCompletoCpa: detalleCompletoCpa
                })
              })

            dispatch({ type: 'BUSQUEDACPA_NEXT_STEP' })
          } else {
            toast.error('No se encontró la carta de porte.', { autoClose: false })
            dispatch(reset(FORM_BUSQUEDACPA))
          }
        })
        .catch((error) => {
          console.log(error)
          dispatch(reset(FORM_BUSQUEDACPA))
        })
    } else if (isNaN(buscarCpa.numero)) {
      toast.error('Número incorrecto')
      dispatch(reset(FORM_BUSQUEDACPA))
    }
  }
}

export function rechazarCpa (onSuccess) {
  return (dispatch, getState) => {
    const state = getState()
    const rechazoCpa = getFormValues(FORM_RECHAZO_EN_PLAYA)(state)
    if (rechazoCpa.motivoRechazo) {
      console.log('Rechazo en playa', rechazoCpa)
      dispatch({ type: 'SHOW_CIRCULAR' })
      dispatch({ type: 'RECHAZAR_CPE_EN_ARCA' })
      Cpa.getById(rechazoCpa.numero)
        .then(cpa => {
          if (cpa && cpa.estadoCtg === 'V') {
            CargaEntranteAutomotorCalado.rechazarCpeEnAfip(cpa.cpeSucursal, cpa.cpeSecuencia, cpa.cuentayorden)
              .then(data => {
                if (data && !data.error) {
                  dispatch({ type: 'RECEIVE_RECHAZAR_CPE_EN_ARCA', data })
                  // deberia devolver 'R'
                  const estadoData = data.rechazarcpe.substr(1, data.rechazarcpe.length - 2).split(',')
                  console.log('estado Data', estadoData)
                  if (estadoData[0] === 'R') { // 'R'
                    Cpa.cambiarEstadoCtg(rechazoCpa.numero, 'R')
                      .then(data => {
                        toast.info('Se rechazó la carta de porte en ARCA')
                        dispatch({ type: 'HIDE_CIRCULAR' })
                        console.log('estado_ctg actualizado', data)
                        dispatch(finalizarRechazo())
                        onSuccess()
                      })
                  } else {
                    toast.info(estadoData[1])
                    dispatch({ type: 'HIDE_CIRCULAR' })
                  }
                } else {
                  toast.error(`Error al rechazar la CPE en ARCA, vuelva a reintentar en unos minutos..`, { autoClose: false })
                  dispatch({ type: 'HIDE_CIRCULAR' })
                  dispatch(finalizarRechazo())
                  onSuccess()
                }
              })
          } else {
            toast.info('El estado del CTG no es el correcto')
            dispatch({ type: 'HIDE_CIRCULAR' })
          }
        })
        .catch((error) => {
          console.log(error)
          dispatch({ type: 'HIDE_CIRCULAR' })
        })
    } else {
      toast.error('Seleccione el Motivo de Rechazo', { autoClose: false })
    }
  }
}
// Para ver
// export function rechazarEnAfip (numero) {
//   return dispatch => {
//     dispatch({ type: 'SHOW_CIRCULAR' })
//     dispatch({ type: 'RECHAZAR_CPE_EN_ARCA' })
//     Cpa.getById(numero)
//       .then(cpa => {
//         if (cpa && cpa.estadoCtg === 'V') {
//           CargaEntranteAutomotorCalado.rechazarCpeEnAfip(cpa.cpeSucursal, cpa.cpeSecuencia, cpa.cuentayorden)
//             .then(data => {
//               dispatch({ type: 'RECEIVE_RECHAZAR_CPE_EN_ARCA', data })
//               // deberia devolver 'R'
//               const estadoData = data.rechazarcpe.substr(1, data.rechazarcpe.length - 2).split(',')
//               console.log('estado', estadoData)
//               if (estadoData[0] === 'R') { // 'R'
//                 Cpa.cambiarEstadoCtg(numero, 'A')
//                   .then(data => {
//                     toast.info('Se rechazó la carta de porte en ARCA')
//                     dispatch(actualizarDatosParaMuiTable())
//                     dispatch({ type: 'HIDE_CIRCULAR' })
//                     console.log('estado_ctg actualizado', data)
//                   })
//               } else {
//                 toast.info(estadoData[1])
//                 dispatch(actualizarDatosParaMuiTable())
//                 dispatch({ type: 'HIDE_CIRCULAR' })
//               }
//             })
//         } else {
//           toast.info('Verifique el estado del CTG')
//           dispatch(actualizarDatosParaMuiTable())
//           dispatch({ type: 'HIDE_CIRCULAR' })
//         }
//       })
//       .catch((error) => {
//         console.log(error)
//         dispatch({ type: 'HIDE_CIRCULAR' })
//       })
//   }
// }
// Para ver

export function abandonarCpa (onSuccess) {
  return (dispatch, getState) => {
    const state = getState()
    const abandonoCpa = getFormValues(FORM_ABANDONO)(state)
    if (abandonoCpa.motivoAbandono) {
      const cpaAbandonada = new CpaAbandonada(abandonoCpa)
      cpaAbandonada.save()
        .then(data => {
          dispatch({
            type: 'ABANDONO_SAVE_STATUS',
            abandonoSaveResponse: data
          })
          if (!data.error) {
            dispatch(finalizarAbandono())
            toast.success('Operación realizada exitosamente.')
            // dispatch(showToast())
            onSuccess()
          }
        })
        .catch((error) => {
          console.log(error)
          dispatch({
            type: 'SHOW_NO_ABANDONABLE',
            abandonoSaveResponse: 'Error al abandonar la carta de porte.'
          })
        })
    } else {
      toast.error('Seleccione el Motivo de Abandono', { autoClose: false })
    }
  }
}

export function finalizarAbandono () {
  return dispatch => {
    dispatch({ type: 'END_ABANDONO' })
  }
}

export function finalizarRechazo () {
  return dispatch => {
    dispatch({ type: 'END_RECHAZO' })
  }
}

export function desabandonarCpa (onSuccess) {
  return (dispatch, getState) => {
    const state = getState()
    const desabandonoCpa = getFormValues(FORM_DESABANDONO)(state)
    const cpaAbandonada = new CpaAbandonada(desabandonoCpa)
    cpaAbandonada.desAbandonar()
      .then(data => {
        dispatch({
          type: 'DESABANDONO_SAVE_STATUS',
          desabandonoSaveResponse: data
        })
        if (!data.error) {
          dispatch(finalizarDesabandono())
          toast.success('Operación realizada exitosamente.')
          // dispatch(showToast())
          onSuccess()
        }
      })
      .catch(_ => dispatch({
        type: 'SHOW_NO_DESABANDONABLE',
        desabandonoSaveResponse: 'Error al desabandonar la carta de porte.'
      }))
  }
}

export function finalizarDesabandono () {
  return dispatch => {
    dispatch({ type: 'END_DESABANDONO' })
  }
}

export function getTurnosPendientesEgreso (turno, cereal) {
  return (dispatch) => {
    CpaEnPlaya.turnosPendientesEgreso(turno, cereal)
      .then(data => {
        dispatch({ type: 'RECEIVE_TURNOS_PENDIENTES_PLAYA', data })
      })
  }
}

export function showDialogoPenalizacion (newValue) {
  return (dispatch) => {
    dispatch({ type: 'SHOW_DIALOGO_PENALIZACION', newValue })
  }
}

export function showDialogoDescargable (newValue, camion, acoplado) {
  return (dispatch) => {
    dispatch({ type: 'SHOW_DIALOGO_DESCARGABLE', payload: { newValue, camion, acoplado } })
  }
}

export function insertarCamionAcopladoEjes (valor, patenteCamion, patenteAcoplado) {
  return (dispatch, getState) => {
    const ejesValores = {
      camion: patenteCamion,
      acoplado: patenteAcoplado,
      cantidadEjes: 0,
      bitren: null,
      autodescargable: valor,
      dimension: null
    }
    CamionAcopladoEjes.altaCamionAcoplado(ejesValores)
      .then(data => {
        if (data && !data.error) {
          toast.success('Operación realizada exitosamente.')
        }
      })
  }
}

export function updateCamionAcopladoEjes (autodescargable, camion, acoplado, callback = null) {
  return (dispatch) => {
    return CamionAcopladoEjes.updateCamionAcopladoEjes(autodescargable, camion, acoplado)
      .then((result) => {
        if (!result.error) {
          toast.success('El camion se modifico correctamente')
          callback && callback()
        } else {
          toast.error('Error al intentar modificar el camion')
        }
      })
  }
}

export function egresoPlayaCpa (onSuccess) {
  return (dispatch, getState) => {
    const state = getState()
    const egresoCpa = getFormValues(FORM_EGRESO)(state)
    CpaEnPlaya.getById(egresoCpa.numero)
      .then(data => {
        dispatch({ type: 'VERIFICAR_ESTADO_CPE', data })
        if (data && !data.error && data.numero) {
          if (data && (data.estadoCtg === 'V' || data.estadoCtg === 'P')) {
            const camion = data.camion.trim()
            const acoplado = data.acoplado.trim()
            if ((data.claveCereal !== 'CEBADACE') || (data.claveCereal === 'CEBADACE' && data.cerealVariedad !== 'UNDEF')) {
              CamionesPenalizados.getPenalizadosVigentes(data.camion, data.claveCereal)
                .then((result) => {
                  if (result && result.patente && (result.patente.trim() === data.camion.trim() || result.patente.trim() === data.acoplado.trim())) {
                    const patente = result.patente
                    const motivo = result.motivo
                    const vencimiento = result.fechaVencimiento
                    dispatch({ type: 'TRANSPORTE_TERRESTRE_PENALIZADO', patente, motivo, vencimiento })
                    dispatch(showDialogoPenalizacion(true))
                  } else {
                    CamionesPenalizados.getPenalizadosVigentes(data.acoplado, data.claveCereal)
                      .then((resultado) => {
                        if (resultado && resultado.patente && (resultado.patente.trim() === data.acoplado.trim() || resultado.patente.trim() === data.acoplado.trim())) {
                          const patente = resultado.patente
                          const motivo = resultado.motivo
                          const vencimiento = resultado.fechaVencimiento
                          dispatch({ type: 'TRANSPORTE_TERRESTRE_PENALIZADO', patente, motivo, vencimiento })
                          dispatch(showDialogoPenalizacion(true))
                        } else {
                          CpaEnPlaya.egresoCpaPlaya(data)
                            .then(data => {
                              if (data && !data.error) {
                                const respStatus = data.length > 0 ? data[0].cartaDePorteAutomotorEgresoPlayaInsert : null
                                const resData = respStatus && respStatus.substr(1, respStatus.length - 2).split(',')
                                // console.log('resData', resData)
                                if (resData && resData[0] > 0) {
                                  dispatch(actualizarDatosParaMuiTableInsatisfecho())
                                  toast.success('Operación realizada exitosamente.')
                                  // Buscar tupla camion y acoplado para verificar si es autodescargable
                                  // en caso de no encontrarse, mostrar ventana de actualizacion
                                  CamionAcopladoEjes.getCamionAcoplado(camion, acoplado)
                                    .then(resultado => {
                                      console.log('Camion acoplado ejes', resultado)
                                      if (!resultado) {
                                        dispatch(showDialogoDescargable(true, camion, acoplado))
                                      }
                                    })
                                } else {
                                  toast.error('No se pudo dar egreso a la CPE, verifique si hay pedidos para este Cereal',
                                    { autoClose: false })
                                }
                                onSuccess()
                              }
                            })
                        }
                      })
                  }
                })
            } else {
              toast.error('No se pudo dar egreso a la CPE porque no tiene asignada Variedad (Cebada Cervecera)',
                { autoClose: false })
            }
          } else {
            toast.error('La CPE no tiene Confirmación de Arribo. Verifique!!',
              { autoClose: false })
          }
          console.log(data)
        } else {
          toast.error('La CPE no está disponible para egreso de playa, verifique si tiene cupo o si ya egreso.',
            { autoClose: false })
        }
      })
      .catch((err) => err)
  }
}

export function pedidoEgresoPlayaCpa (onSuccess) {
  return (dispatch, getState) => {
    const state = getState()
    const pedidoEgresoCpa = getFormValues(FORM_PEDIDO_EGRESO)(state)
    if (pedidoEgresoCpa.cantidad > 0 && pedidoEgresoCpa.cereal != null) {
      PedidoEgreso.ingresoPedido(pedidoEgresoCpa.cereal, pedidoEgresoCpa.cantidad)
        .then(data => {
          if (!data.error) {
            toast.success('Operación realizada exitosamente.')
            dispatch(actualizarDatosParaMuiTable())
            onSuccess()
          }
        })
    } else {
      toast.error('Debe ingresar un Cereal y una cantidad mayor a 0')
    }
  }
}

export function anularIngresoCpa (onSuccess) {
  return (dispatch, getState) => {
    const state = getState()
    const anulacionIngresoCpa = getFormValues(FORM_ANULACION_INGRESO)(state)
    Cpa.anularIngreso(anulacionIngresoCpa.numero)
      .then(deleteStatus => {
        dispatch({
          type: 'ANULACION_INGRESO_STATUS',
          anulacionIngresoDeleteResponse: deleteStatus
        })
        if (!deleteStatus.error) {
          dispatch(finalizarAnulacionIngreso())
          onSuccess()
          toast.success('Operación realizada exitosamente!!!')
        }
      })
  }
}

export function finalizarAnulacionIngreso () {
  return dispatch => {
    dispatch({ type: 'END_ANULACION_INGRESO' })
  }
}

export function setActualizarPresunta (newValue) {
  return (dispatch) => {
    return dispatch({ type: 'SET_ACTUALIZACION_PRESUNTA', newValue })
  }
}

export function actualizarPresunta (codigoCupo) {
  return (dispatch, getState) => {
    const state = getState()
    const formValues = getFormValues(FORM_INGRESO_COMPLETO)(state)
    const { titularDeCupo, cuentayorden } = titularCupoCuentayorden(formValues.titular, formValues.remitenteComercial)
    formValues.titularDeCupo = titularDeCupo
    formValues.cuentayorden = cuentayorden
    return CpaPresunta.updateCpaPresunta(codigoCupo, formValues)
      .then((result) => {
        if (!result.error) {
          toast.success('Los datos se actualizaron')
        } else {
          toast.error(`Error al intentar actualizar los datos del código ${codigoCupo}`)
        }
      })
      .catch((error) => {
        console.log(error)
        toast.error(`Error al intentar actualizar los datos del código ${codigoCupo}`)
      })
  }
}

export function verificarCupo (numero = null) {
  return (dispatch) => {
    dispatch(requestDatosCpa(numero, (cpa) => {
      if (cpa && cpa.tipoCupo && cpa.turnoDeSalida !== null) {
        dispatch(completoNextStep())
      } else {
        dispatch({ type: 'ICOMPLETO_SHOW_SIN_CUPO' })
        dispatch(reset(FORM_INGRESO_COMPLETO))
      }
    }))
  }
}

export function forzarConfirmarArribo (numero) {
  return (dispatch, getState) => {
    console.log('por confirmar...', numero)
    if (numero !== null) {
      return Cpa.getById(numero)
        .then(result => {
          if (result && result.estadoCtg !== 'V') {
            console.log('Result', result)
            return IngresoCompleto.confirmarArriboCPECompleto(result.numero, result.cpeSucursal, result.cpeSecuencia, result.cuentayorden)
              .then(confirmarArribo => {
                console.log('confirmacion', confirmarArribo)
                // dispatch({ type: 'RECEIVE_CONFIRMAR_ARRIBO', confirmarArribo })
                if (confirmarArribo && !confirmarArribo.error) {
                  toast.info('Confirmado en ARCA')
                } else {
                  toast.error('Hubo problemas al confirmar arribo en ARCA')
                }
              })
          } else {
            return { resultado: 'Ya Confirmado' }
          }
        })
    } else {
      toast.error('No se puede verificar el número de CTG')
    }
  }
}

export function confirmarArriboCPE (numero, cpeSucursal, cpeSecuencia, cuentayorden) {
  return (dispatch, getState) => {
    // const state = getState()
    // const iMinimoValues = getFormValues(FORM_INGRESO_MINIMO)(state)
    if (cpeSecuencia !== null && cpeSucursal !== null) {
      console.log('Confirmando Arribo de CPE')
      toast.info('Confirmando Arribo de CPE, este proceso puede demorar unos segundos...')
      dispatch({ type: 'REQUEST_CONFIRMAR_ARRIBO' })
      return IngresoCompleto.confirmarArriboCPE(numero, cpeSucursal, cpeSecuencia, cuentayorden)
        .then(confirmarArribo => {
          // dispatch({ type: 'RECEIVE_CONFIRMAR_ARRIBO', confirmarArribo })
          if (confirmarArribo && !confirmarArribo.error) {
            // dispatch(completoNextStep())
            toast.info('Confirmado en ARCA')
          }
        })
    } else {
      console.log('Continua sin confirmar Arribo')
      // dispatch(completoNextStep())
    }
  }
}

export function confirmarArribo (numero) {
  return (dispatch, getState) => {
    const state = getState()
    const {
      iCompletoValidacionExterna,
      iCompletoCpa
    } = state.camionesIngreso
    const iCompletoValues = getFormValues(FORM_INGRESO_COMPLETO)(state)
    // const { titularDeCupo, cuentayorden } = titularCupoCuentayorden(
    //  iCompletoValues.titular, iCompletoValues.remitenteComercial)
    if (!iCompletoValidacionExterna && iCompletoCpa.estadoCtg === null &&
      iCompletoCpa.ctg === numero && iCompletoCpa.cpeSecuencia !== null && iCompletoCpa.cpeSucursal !== null) {
      console.log('Continua validando CTG')
      toast.info('Confirmando arribo de CPE, este proceso puede demorar...')
      dispatch({ type: 'REQUEST_CONFIRMAR_ARRIBO' })
      // const ingresoCompleto = new IngresoCompleto({
      //  ...iCompletoValues,
      //  cosecha: expandirCosecha(iCompletoValues.cosecha),
      //  titularDeCupo,
      //  cuentayorden
      // })
      // ingresoCompleto.confirmarArribo()
      return IngresoCompleto.confirmarArriboCPE(numero, iCompletoValues.cpeSucursal,
        iCompletoValues.cpeSecuencia, iCompletoValues.titular)
        .then(confirmarArribo => {
          dispatch({ type: 'RECEIVE_CONFIRMAR_ARRIBO', confirmarArribo })
          if (confirmarArribo && !confirmarArribo.error) {
            dispatch(completoNextStep())
          }
        })
    } else {
      console.log('Continua sin validar CTG')
      dispatch(completoNextStep())
    }
  }
}

export function disponibilidadCupoPrevStep () {
  return (dispatch) => {
    return dispatch({ type: 'DISPONIBILIDAD_CUPO_PREV_STEP' })
  }
}

export function finalizarDisponibilidadCupo () {
  return dispatch => {
    dispatch({ type: 'END_DISPONIBILIDAD_CUPO' })
  }
}

export function finalizarBusquedaCpa () {
  return dispatch => {
    dispatch({ type: 'END_BUSQUEDACPA' })
    dispatch(resetFoto())
    dispatch(resetFotoBruto())
  }
}

export function anulacionIngresoNextStep () {
  return (dispatch) => {
    return dispatch({ type: 'ANULACION_INGRESO_NEXT_STEP' })
  }
}

export function anulacionIngresoPrevStep () {
  return (dispatch) => {
    return dispatch({ type: 'ANULACION_INGRESO_PREV_STEP' })
  }
}

export function abandonoNextStep () {
  return (dispatch) => {
    return dispatch({ type: 'ABANDONO_NEXT_STEP' })
  }
}

export function abandonoPrevStep () {
  return (dispatch) => {
    return dispatch({ type: 'ABANDONO_PREV_STEP' })
  }
}

export function desabandonoNextStep () {
  return (dispatch) => {
    return dispatch({ type: 'DESABANDONO_NEXT_STEP' })
  }
}

export function desabandonoPrevStep () {
  return (dispatch) => {
    return dispatch({ type: 'DESABANDONO_PREV_STEP' })
  }
}

export function rechazoNextStep () {
  return (dispatch) => {
    return dispatch({ type: 'RECHAZO_NEXT_STEP' })
  }
}

export function rechazoPrevStep () {
  return (dispatch) => {
    return dispatch({ type: 'RECHAZO_PREV_STEP' })
  }
}

export function completoNextStep () {
  return (dispatch) => {
    return dispatch({ type: 'ICOMPLETO_NEXT_STEP' })
  }
}

export function completoPrevStep () {
  return (dispatch) => {
    return dispatch({ type: 'ICOMPLETO_PREV_STEP' })
  }
}

export function completoupdateCpa (value) {
  return (dispatch) => {
    dispatch({
      type: 'ICOMPLETO_UPDATE_VALUE_CPA',
      value
    })
  }
}

export function resetConsultaCupo () {
  return (dispatch) => {
    dispatch({ type: 'RESET_CONSULTA_CUPO' })
  }
}

export function updateValueConsultaCupo (value) {
  return (dispatch) => {
    dispatch({
      type: 'UPDATE_VALUE_CONSULTA_CUPO',
      value
    })
  }
}

export function submitConsultaCupo (numero = null) {
  return (dispatch, getState) => {
    const consultaCupo = new ConsultaCupo({ numero })
    return consultaCupo.getConsulta()
      .then((data) => dispatch({
        type: 'CONSULTA_CUPO',
        data
      }))
  }
}

export function admitibleEnReimpresion (numero, callback) {
  return (dispatch) => {
    dispatch(requestDatosConsultaCpa(numero, (cpa) => {
      if (cpa && cpa['estadoIngreso'] === 'ingreso_completo') {
        dispatch(reimpresionNextStep())
      } else {
        toast.error('No se ha encontrado la Carta de Porte.', { autoClose: false })
      }
    }))
  }
}

export function reimpresionNextStep () {
  return (dispatch) => {
    return dispatch({ type: 'REIMPRESION_NEXT_STEP' })
  }
}

export function reimpresionPrevStep () {
  return (dispatch) => {
    return dispatch({ type: 'REIMPRESION_PREV_STEP' })
  }
}

export function finalizarReimpresionComprobante () {
  return dispatch => {
    dispatch({ type: 'END_REIMPRESION' })
  }
}

export function iCompletoUpdateEntities (entities, updater) {
  return (dispatch) => {
    return Autocomplete.searchSet(entities.searchSet)
      .then((response) => entities.fields.forEach(field =>
        updater(field, response.shift()[0]))
      )
  }
}

export function updateLocalidad (codigo, updater) {
  return dispatch => {
    return Localidad.getById(codigo)
      .then((localidad) => {
        localidad = localidad.shift()
        if (localidad && updater) {
          updater('localidad', `${localidad.nombre} - (${localidad.codigoPostal})`)
        }
      })
  }
}

export function imprimirEtiquetaIngreso (numero, impresora, reimpresion = null) {
  return dispatch => {
    return Printer.imprimirEtiquetaIngreso({
      numero, impresora, reimpresion
    })
  }
}

export function finalizarIngresoCompleto () {
  return dispatch => {
    dispatch({ type: 'END_ICOMPLETO' })
  }
}

export function submitIngresoCompleto () {
  return (dispatch, getState) => {
    const state = getState()
    const iCompletoValues = getFormValues(FORM_INGRESO_COMPLETO)(state)
    const { titularDeCupo, cuentayorden } = titularCupoCuentayorden(
      iCompletoValues.titular, iCompletoValues.remitenteComercial)
    const {
      iCompletoValidacionExterna,
      iCompletoValidacionResponse,
      iCompletoCpa
    } = state.camionesIngreso
    if (!iCompletoValues.tarifa || !iCompletoValues.tarifaReferencia) {
      return dispatch({
        type: 'ICOMPLETO_SAVE_STATUS',
        iCompletoSaveResponse: {
          message: 'Atención!! Faltan completar algunos campos.\r Verifique Tarifa, Tarifa de Referencia.',
          error: true
        }
      })
    }
    return Localidad.getByNombreAndPostal(iCompletoValues.localidad)
      .then(([localidad]) => new IngresoCompleto({
        ...iCompletoValues,
        fechaDeIngreso: moment(iCompletoValues.fechaDeIngreso).tz('America/Argentina/Buenos_aires').format(),
        fechaDeVencimiento: moment(iCompletoValues.fechaDeVencimiento, 'DD-MM-YY').toDate(),
        fechaCupo: moment(iCompletoValues.fechaCupo).tz('America/Argentina/Buenos_aires').format(),
        fechaAsignacionTurnoDeSalida: moment(iCompletoValues.fechaAsignacionTurnoDeSalida).tz('America/Argentina/Buenos_aires').format(),
        cosecha: expandirCosecha(iCompletoValues.cosecha),
        titularDeCupo,
        cuentayorden,
        localidad: localidad.codigo,
        estadoCtg: iCompletoCpa.estadoCtg === null && iCompletoValidacionExterna ? 'E' : iCompletoCpa.estadoCtg,
        validacionCtg: iCompletoValidacionExterna
          ? iCompletoValues.validacionExterna
          : iCompletoValidacionResponse &&
            iCompletoValidacionResponse.validacion_ctg
      }))
      .then(icompleto => icompleto.save())
      .then(data => {
        dispatch({
          type: 'ICOMPLETO_SAVE_STATUS',
          iCompletoSaveResponse: data
        })
        if (!data.error) {
          if (!iCompletoValidacionExterna && iCompletoCpa.estadoCtg === null) {
            // dispatch(confirmarArribo(iCompletoValues.numero))
            dispatch(confirmarArriboCPE(iCompletoValues.numero, iCompletoValues.cpeSucursal,
              iCompletoValues.cpeSecuencia, iCompletoValues.cuentayorden))
          }
          dispatch(completoNextStep())
        }
      })
  }
}

export function resetControlTurno () {
  return (dispatch) => {
    dispatch({ type: 'RESET_CONTROL_TURNO' })
  }
}

export function obtenerDatosControlTurno () {
  return (dispatch, getState) => {
    dispatch({ type: 'REQUEST_CONTROL_TURNO' })
    const controlTurno = new ControlTurno()
    controlTurno.getControlTurno()
      .then((data) => dispatch({
        type: 'CONTROL_TURNO',
        data
      }))
  }
}

export function submitControlTurno (cpseleccionada = null) {
  // Controlar turnos de camiones
  return (dispatch, getState) => {
    const controlTurno = new ControlTurno()
    controlTurno.setControlDeTurnos(cpseleccionada)
      .then(() => {
        toast.success('Operación realizada exitosamente.')
        dispatch(obtenerDatosControlTurno())
      }
      )
      .catch(() => {
        dispatch({ type: 'ERROR_CONTROL_DE_TURNOS' })
        toast.error('Error al realizar Control de Turnos.', { autoClose: false })
      }
      )
  }
}

export function resetCpaEnPlaya () {
  return (dispatch) => {
    dispatch({ type: 'RESET_CPA_EN_PLAYA' })
  }
}

export function obtenerDatosCpaEnPlaya () {
  return (dispatch, getState) => {
    const cpaEnPlaya = new CpaEnPlaya()
    dispatch({ type: 'REQUEST_CPA_EN_PLAYA' })
    return cpaEnPlaya.getCpaEnPlaya()
      .then((data) => dispatch({
        type: 'CPA_EN_PLAYA',
        data
      }))
  }
}

export function obtenerDatosCpaAbandonada () {
  return (dispatch, getState) => {
    const cpaAbandonada = new CpaAbandonada()
    return cpaAbandonada.getCpaAbandonada()
      .then((data) => dispatch({
        type: 'CPA_ABANDONADA',
        data
      }))
  }
}

export function updateFilter (filters) {
  return (dispatch) => {
    dispatch({ type: 'ACTUALIZAR_FILTROS', filters })
  }
}

export function onChangeColumnWidths (columnWidths) {
  return (dispatch) => {
    dispatch({ type: 'ACTUALIZAR_ANCHO_COLUMNA', columnWidths })
  }
}

export function onChangeSorting (sorting) {
  return (dispatch) => {
    dispatch({ type: 'ACTUALIZAR_SORTING', sorting })
  }
}

export function onChangeSelection (selection) {
  return (dispatch) => {
    dispatch({ type: 'ACTUALIZAR_SELECTION', selection })
  }
}

export function updateFiltersincupos (filters) {
  return (dispatch) => {
    dispatch({ type: 'ACTUALIZAR_FILTROS_SINCUPOS', filters })
  }
}

export function onChangeColumnWidthssincupos (columnWidths) {
  return (dispatch) => {
    dispatch({ type: 'ACTUALIZAR_ANCHO_COLUMNA_SINCUPOS', columnWidths })
  }
}

export function onChangeSortingsincupos (sorting) {
  return (dispatch) => {
    dispatch({ type: 'ACTUALIZAR_SORTING_SINCUPOS', sorting })
  }
}

export function onChangeSelectionsincupos (selection) {
  return (dispatch) => {
    dispatch({ type: 'ACTUALIZAR_SELECTION_SINCUPOS', selection })
  }
}

export function showToast () {
  return dispatch => {
    dispatch({ type: 'SHOW_TOAST' })
  }
}

export function hideToast () {
  return dispatch => {
    dispatch({ type: 'HIDE_TOAST' })
  }
}

export function updateShowInfoVolcadoras (newValue) {
  return dispatch => {
    dispatch({ type: 'SHOW_INFO_VOLCADORAS', newValue })
  }
}

export function queryMinimoBloqueado () {
  return dispatch => {
    dispatch({ type: 'REQUEST_ESTADO_FORMULARIO_MINIMO' })
    ParametroText.getByNombre('MINIMBLQ')
      .then((minimblq) => {
        dispatch({ type: 'RECEIVE_ESTADO_FORMULARIO_MINIMO', minimblq })
      })
  }
}

export function obtenerPesoPromedioCamion () {
  return (dispatch) => {
    ParametroInteger.getByNombre('NETORGDF')
      .then((netoPromedio) => {
        const peso = netoPromedio['valor']
        dispatch({ type: 'RECEIVE_PROMEDIO_CAMION', peso })
      })
  }
}

export function updateParametroInteger (nombre, value) {
  return dispatch => {
    return ParametroInteger.updateByNombre(nombre, value)
  }
}

export function consultaCerealVolcadora () {
  return dispatch => {
    dispatch(cerealAsignadoVolcadora())
    dispatch(cerealVolcadoraOriginal())
  }
}

export function setShowFooterConsultaChofer (show) {
  return (dispatch) => {
    dispatch(setShowFooter(show))
  }
}

export function getCamionesTotal () {
  return (dispatch) => {
    CamionesEnCircuito.getCamionesEnCircuitoPorCereal()
      .then((total) => {
        dispatch({ type: 'RECEIVE_TOTAL_CAMIONES_CEREAL', total })
      })
  }
}

export function getPedidosPlaya () {
  return (dispatch) => {
    PedidoEgreso.getPedidoEgresoPlaya()
      .then((pedido) => {
        dispatch({ type: 'RECEIVE_PEDIDO_EGRESO_PLAYA', pedido })
      })
  }
}

// export function getDetalleMercaderia (numero) {
//   return (dispatch) => {
//     dispatch(obtenerDetalleMercaderia(numero))
//   }
// }

// export function descargarDetalles () {
//   return (dispatch) => {
//     dispatch(descargarDetallesPDF())
//   }
// }

// export function saveDetalle () {
//   return (dispatch) => {
//     dispatch(saveDetallePdf())
//   }
// }

export function getNotificacionesChofer () {
  return (dispatch) => {
    return NotificacionesChofer.getNotificacionesChofer()
      .then((data) => {
        dispatch({ type: 'RECEIVE_NOTIFICACION_CHOFER', data })
      })
  }
}

export function submitNotificacion (notificacion, vencimiento, prioridad) {
  return dispatch => {
    return NotificacionesChofer.submitNotificacion(notificacion, vencimiento, prioridad)
      .then(() => {
        dispatch(getNotificacionesChofer())
      })
  }
}

export function eliminarNotificacion (fechaEmision) {
  return dispatch => {
    return NotificacionesChofer.deleteNotificacion(fechaEmision)
      .then(() => {
        dispatch(getNotificacionesChofer())
      })
  }
}

export function getCortesPedidos () {
  return (dispatch) => {
    return Cereal.getEstadoPedidosCereal()
      .then((data) => {
        dispatch({ type: 'RECEIVE_ESTADO_PEDIDOS_CEREAL', data })
      })
  }
}

export function submitCortePedido (fechaDeCorte, cereal) {
  return (dispatch) => {
    return Cereal.submitCortePedidoCalado(fechaDeCorte, cereal)
      .then(() => {
        dispatch(getCortesPedidos())
      })
  }
}

export function deleteCortePedido (fechaDeCorte, cereal) {
  return (dispatch) => {
    return Cereal.deleteCortePedidoCalado(fechaDeCorte, cereal)
      .then(() => {
        dispatch(getCortesPedidos())
      })
  }
}

export function getCamionesEntrePlayaCalado () {
  return (dispatch) => {
    dispatch({ type: 'REQUEST_CAMIONES_ENTRE_PLAYA_CALADO' })
    return TablaCamionesEntrePlayaCalado.getDataCamionesEnTransito()
      .then((data) => {
        dispatch({ type: 'CAMIONES_ENTRE_PLAYA_CALADO', data })
      })
      .catch((e) => {
        console.log(e)
      })
  }
}

export function getCamionesListosParaBruto () {
  return (dispatch) => {
    dispatch({ type: 'REQUEST_CAMIONES_LISTOS_PARA_BRUTO' })
    return TablaCamionesListosParaBrutoService.getDataCamionesListosParaBruto()
      .then((data) => {
        dispatch({ type: 'CAMIONES_LISTOS_PARA_BRUTO', data })
      })
      .catch((e) => {
        console.log(e)
      })
  }
}

export function getCamionesEntreBrutoYDestare () {
  return (dispatch) => {
    dispatch({ type: 'REQUEST_CAMIONES_ENTRE_BRUTO_DESTARE' })
    return TablaCamionesEntreBrutoYDestareService.getDataCamionesEntreBrutoYDestare()
      .then((data) => {
        dispatch({ type: 'CAMIONES_ENTRE_BRUTO_DESTARE', data })
      })
      .catch((e) => {
        console.log(e)
      })
  }
}
